"use strict";

var processInclude = require("./util");

/* eslint-disable no-undef */
$(document).ready(function () {
    processInclude(require("./components/giftCard"));
});

require("base/components/spinner");
